export const AbortErrorName = 'AbortError';
export function createAbortError() {
    const error = new Error('Aborted');
    error.name = AbortErrorName;
    return { error };
}
export function createPromise() {
    let resolve;
    let reject;
    const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
    });
    return {
        promise,
        resolve,
        reject,
    };
}
export function proxyResponseWithAdditionalNext(response, onEnd) {
    const { next } = response;
    let proxiedNext;
    if (!next) {
        // reach end
        proxiedNext = onEnd(response);
    }
    else {
        // continues the proxy to next
        const promiseControls = createPromise();
        proxiedNext = promiseControls.promise;
        next.then((res) => {
            promiseControls.resolve(proxyResponseWithAdditionalNext(res, onEnd));
        });
    }
    return Object.assign(Object.assign({}, response), { next: proxiedNext });
}
function getLogger(options) {
    if (!options.log) {
        return undefined;
    }
    if (typeof options.log === 'function') {
        return options.log;
    }
    return console.log;
}
export function getFetcherRequestLogger(name, options, cacheKey, request) {
    var _a;
    const logger = getLogger(options);
    if (!logger) {
        return;
    }
    const fullRequestDesc = `${options.cacheKeyPrefix}${cacheKey.slice(0, 6)}(${(_a = JSON.stringify(request)) === null || _a === void 0 ? void 0 : _a.slice(0, 12)})`;
    return (log) => logger(`${name}<${fullRequestDesc}> ${log}`);
}
